<app-banner [heading]="'OUR INFRA - PLAYGROUND'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
   
    
    <!-- ======= About Section ======= -->
    <section id="about" class="about">

      <div class="container">
        <div class="row">

          <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/playgrounds/playground-1.jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-lg-6 col-md-6">
            <div class="about-content">
              <h6 class=""> Playground </h6>
              
              <p>Having a playground in the school has become luxury these days because of non availability
			  of land and high price but fortunately <strong>Tagore Global School</strong>has adequate space for the 
			  physical development of our students.<br><br>Big playground for students to play Football, Cricket , 
			  Basketball, VolleyBall, Lawn-Tennis and Athletics etc.

			  
			  </p>
              
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/playgrounds/playground-2.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/playgrounds/playground-3.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/playgrounds/playground-4.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/playgrounds/playground-5.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/playgrounds/playground7.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/playgrounds/playground8.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  		  <div class="col-lg-12 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/playgrounds/playground9.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-12 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/playgrounds/playground-6.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 
		  
		</div>
      </div>
	</section><!-- End About Section -->

	
	
    
    
  </main>